export default __webpack_public_path__ + "static/media/Check cr-fr.3091e4b3.svg";